const customLangs = {
    gb: {
        _name: 'English',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            }
        }
    },
    ru: {
        _name: 'Русский',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            }
        }
    },
    pl: {
        _name: 'Polski',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            }
        }
    },
    cz: {
        _name: 'Čeština',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            }
        }
    },
    de: {
        _name: 'Deutsch',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            }
        }
    },
    fr: {
        _name: 'Français',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            }
        }
    },
    es: {
        _name: 'Español',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            }
        }
    },
    dk: {
        _name: 'Dansk',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            }
        }
    },
    nl: {
        _name: 'Nederlandse taal',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            }
        }
    },
    sa: {
        _name: 'عربي',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            }
        }
    },
    it: {
        _name: 'Italiano',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            }
        }
    },
    sk: {
        _name: 'Slovak',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            }
        }
    },
    hu: {
        _name: 'Hungarian',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            }
        }
    },
    ro: {
        _name: 'Romanian',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            }
        }
    },
    ge: {
        _name: 'Georgia',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            }
        }
    },
    az: {
        _name: 'Azerbaijani',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            }
        }
    },
    tr: {
        _name: 'Türkçe',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            }
        }
    },
    rs: {
        _name: 'Srpski',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            }
        }
    },
    pt: {
        _name: 'Português',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            }
        }
    },
    jp: {
        _name: '日本語',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            }
        }
    },
    hr: {
        _name: 'Hrvatski',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            }
        }
    },
    kz: {
        _name: 'Қазақ тілі',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            }
        }
    },
    kg: {
        _name: 'Кыргыз тили',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            }
        }
    },
    cn: {
        _name: '中文',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            }
        }
    }
}

export default customLangs
